export default __webpack_public_path__ + "3e5ada1.png";